import { Component, OnInit } from '@angular/core';

import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import { DEPARTMENT_TYPE_CLASSES } from 'src/app/core/constants';

@Component({
    selector: 'app-classes-ranking',
    templateUrl: './classes-ranking.component.html',
    styleUrls: ['./classes-ranking.component.scss'],
})
export class ClassesRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Classes
     */
    public departmentType: string = DEPARTMENT_TYPE_CLASSES;
    public pathRoute: string = 'classes';

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
